module.exports = __webpack_public_path__ + "media/images/application/icons/header-logo-zed-1d016b852737a19e569da3aafe8008af.svg";